import { render, staticRenderFns } from "./Subtitle.vue?vue&type=template&id=3fd596f5"
import script from "./Subtitle.vue?vue&type=script&lang=ts"
export * from "./Subtitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports